import React from 'react';
import { getWebComponentUrl } from "./MyKBBUrls";
export default (function (_ref) {
  var userwcbranch = _ref.userwcbranch;
  return [React.createElement("script", {
    async: true,
    key: "authScript",
    type: "module",
    src: getWebComponentUrl({
      userwcbranch: userwcbranch
    })
  }), React.createElement("script", {
    async: true,
    key: "authScriptNoModule",
    noModule: true,
    src: getWebComponentUrl({
      userwcbranch: userwcbranch
    })
  })].concat();
});